<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader :title="$t('Reports')" :description="$t('Purchases by invoices')" />

        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">
              <i class="fal fa-edit"></i>
              {{ $t('Reports options') }}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <searchInput
                class="col-md-3"
                :title="$t('Supplier')"
                :plaseholder="$t('Choose supplier')"
                :show="'name'"
                :refrance="'id'"
                v-model="params.supplier_id"
                :value="params.supplier_id"
                :values="$database.suppliers"
              />
              <dateFilter class="col-md-3" />
              <searchInput
                class="col-md-3"
                :title="$t('user')"
                :plaseholder="$t('Choose user')"
                :show="'name'"
                :refrance="'id'"
                v-model="params.user_id"
                :value="params.user_id"
                :values="$database.users"
              />
              <searchInput
                class="col-md-3"
                :title="$t('project')"
                :plaseholder="$t('Choose project')"
                :show="'name'"
                :refrance="'id'"
                v-model="params.project_id"
                :value="params.project_id"
                :values="$database.projects"
              />
              <div class="col-md-3">
                <div class="form-group">
                  <label>{{ $t('Status type') }}</label>

                  <select v-model="params.status" type="text" class="form-control">
                    <option value="">{{ $t('situation') }}</option>
                    <option value="">{{ $t('all') }}</option>
                    <option value="0">{{ $t('draft') }}</option>
                    <option value="1">{{ $t('sent') }}</option>
                    <option value="2">{{ $t('seen') }}</option>
                    <option value="3">{{ $t('driven') }}</option>
                    <option value="4">{{ $t('canceled') }}</option>
                  </select>
                </div>
              </div>
              <searchInput
                class="col-md-3"
                :title="$t('Store')"
                :plaseholder="$t('Choose store')"
                :show="'name'"
                :refrance="'id'"
                v-model="params.store_id"
                :value="params.store_id"
                :values="$database.stores"
              />

              <actionButtons class="col-md-3" />
            </div>
          </div>
        </div>
        <div id="reportShow">
          <reportHeader
            :title="$t('Purchase by invoice report')"
            :details="[
              { title: $t('Supplier name'), value: supplierName },
              { title: $t('Username'), value: userName },
              { title: $t('Store'), value: storeName }
            ]"
          />
          <reportTable
            :emptyTableText="$t('there are no data at the moment')"
            :emptyTableSubText="$t('Try adding some items and try again')"
            :cloumns="[
              {
                column: 'code',
                link: '/bills',
                title: $t('Code'),
                type: 'reportMainLink',
                sort: true
              },
              { column: 'date', title: $t('Date'), type: 'text', sort: true },
              {
                column: 'client_type',
                title: $t('Supplier name'),
                type: 'clintLink',
                sort: false
              },
              { column: 'user', title: $t('User'), type: 'text', sort: true },
              {
                column: 'subtotal',
                title: $t('Total'),
                type: 'text',
                sort: true
              },
              {
                column: 'edit',
                title: $t('Edit'),
                type: 'text',
                sort: true
              },
              {
                column: 'delivery',
                title: $t('Shipping fees'),
                type: 'text',
                sort: true
              },
              {
                column: 'tax',
                title: $t('Taxes'),
                type: 'text',
                sort: true
              },
              {
                column: 'discount',
                title: $t('Discount'),
                type: 'text',
                sort: true
              },
              {
                column: 'total',
                title: $t('Total'),
                type: 'text',
                sort: true
              }
            ]"
            :footer="[
              { colspan: 1, value: $t('Total') },
              { colspan: 3, value: invoicesCount },
              { colspan: 1, value: subtotal },
              { colspan: 1, value: edit },
              { colspan: 1, value: delivery },
              { colspan: 1, value: tax },
              { colspan: 1, value: discount },
              { colspan: 1, value: total }
            ]"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import reportHeader from '@/elements/reports/reportHeader.vue'
import reportTable from '@/elements/reports/reportTable.vue'
import indexHeader from '@/elements/index/indexHeader.vue'
import dateFilter from '@/elements/reports/dateFilter.vue'
import searchInput from '@/elements/reports/searchInput.vue'
import actionButtons from '@/elements/reports/actionButtons.vue'

export default {
  data() {
    return {
      path: '/reports/purchases/bills',
      items: [],
      loading: 1,
      invoicesCount: 0,
      subtotal: 0,
      edit: 0,
      delivery: 0,
      tax: 0,
      discount: 0,
      total: 0,

      params: {
        supplier_id: '',
        store_id: '',
        user_id: '',
        point_of_sale_id: '',
        dateFilter: 2,
        startDate: '',
        endDate: ''
      },

      excel: {
        fileName: 'purchase by invoice',
        reportData: '[]'
      },

      users: [],
      supplierName: '',
      userName: '',
      storeName: '',

      searchStartDate: '',
      searchEndDate: ''
    }
  },
  methods: {
    getData() {
      this.$setParams(this.params)
      this.loading = 1
      this.totalPages = 0
      this.items = []
      axios.get(this.$linkGenerator(this.path), { params: this.params }).then((response) => {
        this.items = response.data

        this.searchStartDate = this.params.startDate
        this.searchEndDate = this.params.endDate

        this.subtotal = 0
        this.edit = 0
        this.delivery = 0
        this.tax = 0
        this.discount = 0
        this.total = 0

        this.invoicesCount = this.items.length
        this.items.forEach((item) => {
          this.subtotal += item.subtotal
          this.edit += item.edit
          this.delivery += item.delivery
          this.tax += item.tax
          this.discount += item.discount
          this.total += item.total

          item.subtotal = this.$moneyFormat(item.subtotal)
          item.discount = this.$moneyFormat(item.discount)
          item.total = this.$moneyFormat(item.total)
          item.tax = this.$moneyFormat(item.tax)
          item.edit = this.$moneyFormat(item.edit)
          item.delivery = this.$moneyFormat(item.delivery)

          if (item.client_type == 0) {
            var supplier = this.$database.customers.find((el) => el.id == item.customer_id)
            if (supplier) {
              item.customer = supplier
            }
          } else {
            var supplier = this.$database.suppliers.find((el) => el.id == item.supplier_id)
            if (supplier) {
              item.supplier = supplier
            }
          }

          var user = this.users.find((el) => el.id == item.user_id)
          if (user) {
            item.user = user.name
          }

          item.date = this.$dateFormat(item.date)
        })
        this.subtotal = this.$moneyFormat(this.subtotal)
        this.discount = this.$moneyFormat(this.discount)
        this.total = this.$moneyFormat(this.total)
        this.tax = this.$moneyFormat(this.tax)
        this.delivery = this.$moneyFormat(this.delivery)
        this.edit = this.$moneyFormat(this.edit)

        this.loading = 0
      })

      var supplier = this.$database.suppliers.find((el) => el.id == this.params.supplier_id)
      if (supplier) {
        this.supplierName = supplier.name
      } else {
        this.supplierName = ''
      }

      var store = this.$database.stores.find((el) => el.id == this.params.store_id)
      if (store) {
        this.storeName = store.name
      } else {
        this.storeName = ''
      }
      var user = this.users.find((el) => el.id == this.params.user_id)
      if (user) {
        this.userName = user.name
      } else {
        this.userName = ''
      }
    },
    getItems() {
      this.$setParams(this.params)
      var params = this.params
      this.$setParams(params)
      if (params.orderBy) {
        this.items.sort(this.$dynamicSort(params))
      }
    }
  },
  watch: {
    items: function () {
      var mainElemnt = this
      setTimeout(() => {
        var title = document.querySelector('.report-title').textContent
        var data = document.querySelector('.report-data').textContent
        var date = document.querySelector('.report-date').textContent
        var header = [title, data, date]
        var table = document.querySelector('table')
        var reportData = [...table.rows].map((r) =>
          [...r.querySelectorAll('th, td')].map((td) => td.textContent)
        )
        reportData.unshift(header)
        mainElemnt.excel.reportData = JSON.stringify(reportData)
      }, 100)
    }
  },
  mounted() {
    this.params = this.$getParams()
    if (typeof this.params.startDate === 'undefined') {
      this.params.startDate = new Date()
        .toISOString('en-US', { timeZone: 'Africa/Cairo' })
        .slice(0, 10)
    }
    this.$updateDatabase(['users'])

    this.getData()
  },
  components: {
    reportHeader,
    reportTable,
    indexHeader,
    dateFilter,
    searchInput,
    actionButtons
  }
}
</script>
